import {EntityService} from '../../service/EntityService';

export class StatementInvoiceService extends EntityService {

  static entity = 'app/statement-invoice';

  static getByInvoice(invoiceId: string): Promise<any> {
    return this.axios.get(`${this.entity}/pre-add/${invoiceId}`).then(res => res.data);
  }

  static upload(invoiceId: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/upload/${invoiceId}`, data).then(res => res.data);
  }

  static getPdfUrl(id: string): string {
    return `${this.baseURL}/${this.entity}/${id}/downloaf-pdf`;
  } 

}
